export default __webpack_public_path__ + "static/media/ALPHAWIN-logo.6a797735.png";